import { createContext } from 'react';
import { UserType, HexoscopeUserType } from './../types';

export const UserContext = createContext({
  user: null as null | UserType,
  setUser: (user: UserType) => {},
  hexoscopeUser: null as HexoscopeUserType | null,
  setHexoscopeUser: (hexoscopeUser: HexoscopeUserType | null) => {},
});
